import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useLoansStore} from "../../store/loans.store";

export const useLoan = () => {
    const setLoan = useLoansStore((state) => state.setLoan);

    return useMutation(PartnerApi.loan, {
        onSuccess: (data) => {
            setLoan(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};